import { motion } from "framer-motion";
import groomPhoto from "@/assets/couple/groom.jpeg";
import bridePhoto from "@/assets/couple/bride.jpeg";
import defaultTexture from "@/assets/decoration/floral-texture.png";

interface CoupleSectionProps {
  groomUrl?: string | null;
  brideUrl?: string | null;
  floralTexture?: string;
}

export function CoupleSection({
  groomUrl,
  brideUrl,
  floralTexture,
}: CoupleSectionProps) {
  return (
    <section
      id="couple"
      className="relative w-full py-20 px-6 bg-[#F7F5F2] overflow-hidden"
    >
      {/* Background Texture */}
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          backgroundImage: `url(${floralTexture || defaultTexture})`,
          backgroundSize: "400px",
          backgroundRepeat: "repeat",
        }}
      />

      <div className="max-w-md mx-auto relative">
        <div className="text-center mb-16">
          <motion.p
            className="font-serif italic text-lg text-stone-600 mb-2"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيم
          </motion.p>
          <motion.p
            className="text-sm text-stone-500 max-w-xs mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Dengan memohon rahmat dan ridho Allah SWT, kami bermaksud
            menyelenggarakan pernikahan putra-putri kami:
          </motion.p>
        </div>

        {/* Groom */}
        <div className="relative mb-24">
          <motion.div
            className="absolute -top-4 -right-2 w-48 h-64 bg-stone-200 shadow-lg rotate-3 z-0 border-[8px] border-white overflow-hidden"
            initial={{ opacity: 0, scale: 0.9, rotate: 0 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 3 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img
              src={groomUrl || groomPhoto}
              alt="Mempelai Pria"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            className="relative z-10 pt-[15.5rem] pr-12 text-right"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <p className="font-serif text-lg font-bold text-stone-700">
              Mochamad Nauval Dwisatya S.Tr.Kom
            </p>
            <p className="text-xs text-stone-500 mt-1">
              Putra ke-2 dari Bpk. Asep Setiawan & Ibu Ai Jubaedah
            </p>
          </motion.div>
        </div>

        {/* Bride */}
        <div className="relative mt-12 text-left">
          <motion.div
            className="absolute -top-6 -left-2 w-48 h-64 bg-stone-200 shadow-lg -rotate-2 z-0 border-[8px] border-white overflow-hidden"
            initial={{ opacity: 0, scale: 0.9, rotate: 0 }}
            whileInView={{ opacity: 1, scale: 1, rotate: -2 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img
              src={brideUrl || bridePhoto}
              alt="Mempelai Wanita"
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div
            className="relative z-10 pt-[15.5rem] pl-12"
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <p className="font-serif text-lg font-bold text-stone-700">
              Rifa Fauziah Wahyuni S.Tr.AP
            </p>
            <p className="text-xs text-stone-500 mt-1">
              Putri ke-2 dari Bpk. Asep Wahyudin & Ibu Lina Rachmawati
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
